




































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { phone } from "@/validators/custom";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";

@Component({
  components: {
    FormValidation
  }
})
export default class Contact extends Vue {
  @Prop() quote_name!: string;
  @Prop() contact_name!: string;
  @Prop() company_name!: string;
  @Prop() phone!: string;
  @Prop() email!: string;

  @Watch("$v.$invalid", { deep: true })
  onFormChange(): void {
    this.validateForm();
  }

  @Validations()
  validations() {
    return {
      contact_name: { required },
      quote_name: { required },
      company_name: { required },
      phone: { phone, required },
      email: { email, required }
    };
  }

  created() {
    EventBus.$on("submitCheckoutForm", this.validateForm);
    EventBus.$on("saveQuote", this.validateForm);
  }

  beforeDestroy() {
    EventBus.$off("submitCheckoutForm");
    EventBus.$off("saveQuote");
  }

  protected validateForm(): void {
    this.$v.$touch();
    this.$emit("sendError", this.$v.$invalid, "contact");
  }

  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
    if (this.$v[fieldName]) {
      this.$v[fieldName]!.$touch();
      this.validateForm();
    }
  }
}
